export default "__VITE_ASSET__CgzAZlKc__"